import { useState } from 'react'
import type { FormEvent } from 'react'

/** 본인 비밀번호 변경 */
export default function PasswordDialog({ onClose, onDone }: { onClose: () => void; onDone: (msg: string) => void }) {
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  const submit = async (e: FormEvent) => {
    e.preventDefault()
    if (busy) return
    if (next !== confirm) return setError('새 비밀번호가 서로 다릅니다.')
    setBusy(true)
    setError('')
    try {
      const res = await fetch('/api/auth/password', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ current, next }),
      })
      const data = await res.json()
      if (!res.ok) throw new Error(data.error || `오류 ${res.status}`)
      onDone('비밀번호를 변경했습니다.')
      onClose()
    } catch (err: any) {
      setError(err?.message ?? String(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="modal-backdrop" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal auth-modal">
        <div className="modal-head">
          <b>비밀번호 변경</b>
          <button className="modal-x" onClick={onClose} aria-label="닫기">
            ✕
          </button>
        </div>
        <form onSubmit={submit} className="auth-form">
          <label>
            현재 비밀번호
            <input
              autoFocus
              type="password"
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
              autoComplete="current-password"
            />
          </label>
          <label>
            새 비밀번호
            <input
              type="password"
              value={next}
              onChange={(e) => setNext(e.target.value)}
              autoComplete="new-password"
              placeholder="6자 이상"
            />
          </label>
          <label>
            새 비밀번호 확인
            <input
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              autoComplete="new-password"
            />
          </label>
          {error && <div className="auth-error">{error}</div>}
          <button className="auth-submit" type="submit" disabled={busy || !current || !next || !confirm}>
            {busy ? '처리 중…' : '변경하기'}
          </button>
        </form>
      </div>
    </div>
  )
}
